module.exports = __webpack_public_path__ + "static/media/spanish.966ccd12.png";